// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Result from "../Data.Result/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Addresses_Types from "../Restaumatic.Addresses.Types/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Restaumatic_Validation_Types from "../Restaumatic.Validation.Types/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var ClaimFODResponse = function (x) {
    return x;
};
var ClaimFODRequest = function (x) {
    return x;
};
var eqClaimFODResponse = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Result.eqResult(Data_Eq.eqArray(Restaumatic_Validation_Types.eqError))(Data_Eq.eqBoolean))(x.result)(y.result);
        };
    }
};
var eqClaimFODRequest = {
    eq: function (x) {
        return function (y) {
            return x.email === y.email && x.phone === y.phone && Data_Eq.eq(Restaumatic_Restaurant_Types_Id.eqRestaurantId)(x.restaurantId)(y.restaurantId) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Addresses_Types.eqStreetAddressWithApartm))(x.streetAddress)(y.streetAddress);
        };
    }
};
var rpcMethodNameClaimFODRequest = {
    rpcMethodName: function (v) {
        return "ClaimFODRequest";
    }
};
var newtypeClaimFODResponse = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeClaimFODRequest = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldClaimFODResponse = function (dictHasField) {
    return dictHasField;
};
var hasFieldClaimFODRequest = function (dictHasField) {
    return dictHasField;
};
var genericClaimFODResponse = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showClaimFODResponse = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericClaimFODResponse)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "result";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Result.showResult(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Validation_Types.showError))(Data_Show.showBoolean)))))({
        reflectSymbol: function () {
            return "ClaimFODResponse";
        }
    }))
};
var unscrambleDecodeClaimFODResponse = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericClaimFODResponse)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "result";
        }
    })(/* #__PURE__ */ Data_Result.udecodeResult(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Validation_Types.udecode))(Unscramble.decodeBoolean1))(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var genericClaimFODRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showClaimFODRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericClaimFODRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "email";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "phone";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "streetAddress";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Addresses_Types.showStreetAddressWithApartment)))(Restaumatic_Restaurant_Types_Id.showRestaurantId))(Data_Show.showString))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "ClaimFODRequest";
        }
    }))
};
var unscrambleDecodeClaimFODRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericClaimFODRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "email";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "phone";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Restaumatic_Restaurant_Types_Id.udecodeRestaurantId)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "streetAddress";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Addresses_Types.unscrambleDecodeStreetAddressWithApartment))(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeClaimFODResponse = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericClaimFODResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ClaimFODResponse";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "result";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Result.encodeResult(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Validation_Types.encodeError))(Foreign_Generic_Class.booleanEncode)))))))(encodingOpts)
};
var encodeClaimFODRequest = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericClaimFODRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ClaimFODRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "streetAddress";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Addresses_Types.encodeStreetAddressWithApartment))))({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.encodeRestaurantId)))({
        reflectSymbol: function () {
            return "phone";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "email";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(encodingOpts)
};
var decodeClaimFODResponse = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericClaimFODResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ClaimFODResponse";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "result";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Result.decodeResult(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Validation_Types.decodeError))(Foreign_Generic_Class.booleanDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeClaimFODRequest = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericClaimFODRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ClaimFODRequest";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "streetAddress";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Addresses_Types.decodeStreetAddressWithApartment)))())({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.decodeRestaurantId))())({
        reflectSymbol: function () {
            return "phone";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "email";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    ClaimFODRequest,
    ClaimFODResponse,
    encodingOpts,
    genericClaimFODRequest,
    showClaimFODRequest,
    eqClaimFODRequest,
    decodeClaimFODRequest,
    unscrambleDecodeClaimFODRequest,
    encodeClaimFODRequest,
    newtypeClaimFODRequest,
    hasFieldClaimFODRequest,
    rpcMethodNameClaimFODRequest,
    genericClaimFODResponse,
    showClaimFODResponse,
    eqClaimFODResponse,
    decodeClaimFODResponse,
    unscrambleDecodeClaimFODResponse,
    encodeClaimFODResponse,
    newtypeClaimFODResponse,
    hasFieldClaimFODResponse
};
//# sourceMappingURL=index.js.map
